module.exports = __webpack_public_path__ + "static/media/account.a7041ce2.svg";